import { IDataManager } from './idata_manager';
import { UADataManager } from './ua_data_manager';
import { AGDataManager } from './ag_data_manager';
import { ITranslator } from '../translators/itranslator';
import { OauthConfig, OauthClient } from '../../http/oauth_client';
import { AjaxHelperConfig } from '../../http/ajax_helper_config';
import { OnlineCheckHelper } from '../../common_utils/online_check_helper';
import { RespCacheHelper } from '../../common_utils/resp_cache_helper';
import { AjaxHelper } from '../../http/ajax_helper';

export interface IDiscoveryEndPoints{
    pictService: string,
    uaPictService?: string,
    libraryService: string,
    accountsService: string
}

/**
 * Config object to prepare the input for the DataManagerFactory to get either UA or AG managers. 
 * @export
 * @interface IClientConfig
 */
export interface IClientConfig {
    translator?: ITranslator;
    userType?: String;
    oauthInfo: OauthConfig;
    getNewAccessToken: any;// function
    redirectToLoginFunc:any;// function
    discoveryEndPoints: IDiscoveryEndPoints;
    iscorsRequired: boolean;
    oauthStartTime:number;
    isRespCachingEnabled:boolean;
    enableApiHitWithMainHost:boolean;
}


/**
 * Responsible to create either User Assets or Aggregator data manager object. 
 * @export
 * @class DataManagerFactory
 */
export class DataManagerFactory {
    static uaDataManager: UADataManager;
    static agDataManager: AGDataManager;


    /**
     * Returns either UserAssets or Aggregation singleton object based on the input config object userType value
     * @static
     * @param {IClientConfig} config
     * @returns {IDataManager}
     * @memberof DataManagerFactory
     */
    static getInstance(config: IClientConfig): IDataManager {

        OauthClient.setOauthConfig(config.oauthInfo, config.getNewAccessToken,
            config.discoveryEndPoints.libraryService,config.oauthStartTime,config.redirectToLoginFunc);
        OnlineCheckHelper.setOnlineService(config.discoveryEndPoints.libraryService);
        AjaxHelperConfig.setCorsProxySettings(config.discoveryEndPoints.libraryService, config.iscorsRequired);
        AjaxHelperConfig.setGlobalConfiguration(config);
        RespCacheHelper.updateFeatureStatus(config.isRespCachingEnabled || false);
        if (config.userType === 'AGG') {
            if (DataManagerFactory.agDataManager) return DataManagerFactory.agDataManager;
            return DataManagerFactory.agDataManager = new AGDataManager(config);
        } else { // userType === "NON-AGG"
            if (DataManagerFactory.uaDataManager) return DataManagerFactory.uaDataManager;
            return DataManagerFactory.uaDataManager = new UADataManager(config);
        }
    }

    /**
     * appending url and height parameter
     *
     * @static
     * @memberof Util
     */
    static appendHeightToURL = function(url: string, height: number, type: string){
        const tnUrl = new URL(url);
        tnUrl.searchParams.append(type, ""+height);
        return tnUrl.href;
    }
    
}